import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { MatDialog } from '@angular/material/dialog';
import { MessageSeverity, AlertService } from 'src/app/shared/services/alert.service';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { PanelIOTService } from 'src/app/services/panel-iot/panel-iot.service';
import { HeadquarterService } from 'src/app/services/headquarter/headquarter.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { EnterpriseService } from 'src/app/services/enterprise/enterprise.service';
import * as ExcelJS from 'exceljs';
import { Chart } from 'chart.js';
import { GatewayService } from 'src/app/services/gateway/gateway.service';
import { MatTableDataSource } from '@angular/material/table';
import { ZoneService } from 'src/app/services/zone/zone.service';
import {DateAdapter, MAT_DATE_FORMATS} from '@angular/material';
import { APP_DATE_FORMATS, AppDateAdapter } from 'src/app/shared/helpers/format-datepicker';
import { ReportPanelIOTSensor } from 'src/app/models/panelIOT/reportPanelIOTSensor';

@Component({
  selector: 'app-iot-report',
  templateUrl: './iot-report.component.html',
  styleUrls: ['./iot-report.component.css'],
  providers: [
    {provide: DateAdapter, useClass: AppDateAdapter},
    {provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS}
  ]
})
export class ReportIOTComponent implements OnInit {

  cameraSelect: number;
  cameraAlertType = [];
  reportForm: FormGroup;
  myDate = new Date();
  alertSelect: number = 0;
  date = new Date();
  dateF = new Date();
  timeI: string;
  timeF: string;
  dateV:string;
  isAdministrator=false;
  dateIView:string;
  dateFView:string;

  dropdownList = [];
  selectedItems = [];
  dropdownSettings:IDropdownSettings;
  chartItem:any;

  labelsChart = [];
  dataChart:any;
  isAdminGys: boolean = false;
  enterprises = [];
  headquarters = [];
  gateways = [];
  enterpriseSelect: number = 0;
  pageEvent: PageEvent;
  pageIndex: number = 0;
  pageSize: number = AppConstants.Paginado.DEFAULT_PAGE_SIZE_PAGINATION;
  length: number = 0;
  page: number = 1;
  headquarterSelect: number = 0;
  gatewaySelect: number = 0;
  zones = [];
  zoneSelect: number = 0;
  valueTypes = [];
  valueTypeSelect: string = "0";
  sensors = [];

  dataSource = new MatTableDataSource<ReportPanelIOTSensor>();
  displayedColumns: string[] = ['index', 'headquarter', 'zone','isActuator', 'sensor', 'type', 'value', 'date']; // 'gateway',
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild('paginatorTop', { static: false }) paginatorTop: MatPaginator;
  @ViewChild('paginatorBottom', { static: false }) paginatorBottom: MatPaginator;
  color1: string;
  color2: string;
  colorFont: string;
  colorFont2: string;

  constructor(
    private datePipe: DatePipe,
    public dialog: MatDialog,
    private AlertService: AlertService,
    private formBuilder: FormBuilder,
    private panelIOTService: PanelIOTService,
    private headquarterService: HeadquarterService,
    private spinner: NgxSpinnerService,
    private enterpriseService: EnterpriseService,
    private gatewayService: GatewayService,
    private zoneService: ZoneService
  ) {
    document.getElementById("titleHeaderNav").innerHTML = 'IOT > <span class="font-weight-bold">Reporte de Actuadores y Sensores</span>';
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'idSensor',
      textField: 'sensor',
      tooltipField: 'Sensor',
      selectAllText: 'Todos',
      unSelectAllText: 'Limpiar',
      searchPlaceholderText: 'Buscar',
      noFilteredDataAvailablePlaceholderText: 'Item no encontrado',
      itemsShowLimit: 6,
      allowSearchFilter: false, //input search
    };
  }

  ngOnInit(): void {
    this.setTheme();
    this.isAdminGys = (+localStorage.getItem(AppConstants.Session.ROLID) == AppConstants.UserRole.AdministradorGyS || +localStorage.getItem(AppConstants.Session.ROLID) == AppConstants.UserRole.UsuarioGyS) ? true : false;
    this.createForm();
    this.enterpriseSelect = (+localStorage.getItem(AppConstants.Session.ENTERPRISE));
    this.headquarterSelect = (+localStorage.getItem(AppConstants.Session.HEADQUARTER));
    this.getHeadquarters();
    this.timeI = this.datePipe.transform("Tue Aug 18 2020 00:00:58 GMT-0500", 'HH:mm');
    this.timeF = this.datePipe.transform("Tue Aug 18 2020 23:59:58 GMT-0500", 'HH:mm');
    this.dateV = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
    this.dataSource.paginator = this.paginator;
  }

  setTheme(){
    this.color1 = localStorage.getItem(AppConstants.Session.THEME_COLOR1);
    this.color2 = localStorage.getItem(AppConstants.Session.THEME_COLOR2);
    this.colorFont = localStorage.getItem(AppConstants.Session.THEME_COLOR_FONT);
    this.colorFont2 = localStorage.getItem(AppConstants.Session.THEME_COLOR_FONT2);
  }

  ngAfterContentChecked(): void {
    if (this.paginatorTop) {
      this.paginatorBottom.length = this.paginatorTop.length;
    }
}

onDeSelect(item: any) {
  this.selectedItems = this.selectedItems.filter(x => x.idSensor !== item.idSensor);
}

handlePaginatorTop(e): void {
    const { pageSize, pageIndex } = e;
    this.paginatorTop.pageSize = pageSize
    this.paginatorTop.pageIndex = pageIndex;
    this.paginatorTop.page.emit(e);
}

handlePaginatorBottom(e): void {
    const { pageSize, pageIndex } = e;
    this.paginatorBottom.pageSize = pageSize
    this.paginatorBottom.length = this.paginatorTop.length;
    this.paginatorBottom.pageIndex = pageIndex;
  }

  createForm(){
    this.reportForm = this.formBuilder.group({
      startDateReport: ['', [Validators.required]],
      endDateReport: ['', [Validators.required]],
      startTimeReport: ['', [Validators.required, Validators.pattern("^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$")]],
      endTimeReport: ['', [Validators.required, Validators.pattern("^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$")]],
      idEnterprise: ['', [Validators.required]],
      idHeadquarter: ['', [Validators.required]],
      idGateway: ['', [Validators.required]],
      idZone: ['', [Validators.required]],
      valueType: ['', [Validators.required]],
      idSensors: ['']
    });
  }

  getEnterprises() {
    this.spinner.show();
    if (this.isAdminGys) {
      this.enterpriseService.getEnterprises().subscribe((response) => {
        this.enterprises = response.filter(f => f.enabled == AppConstants.Flag.Active);
        this.enterpriseSelect = this.enterprises[0]["enterpriseId"];
        this.getHeadquarters();
      },
        (error: HttpErrorResponse) => {
          this.spinner.hide();
        });
    } else {
      this.enterpriseSelect = +localStorage.getItem(AppConstants.Session.ENTERPRISE);
      this.getHeadquarters();
    }
  }

  _keyUp(event: any) {
    let charCode = (event.which) ? event.which : event.keyCode;
      console.log(event.keyCode)
      if (charCode != 46 && charCode != 58 && charCode > 31
        && (charCode < 48 || charCode > 57)) {
        return false;
      }
  }


  get f() { return this.reportForm.controls; }
   onItemSelect(item: any) {
    this.selectedItems.push(item);
  }

  onSelectAll(items: any) {
    this.selectedItems = [...items];
  }

  onFilterChange(item: any){
    console.log("onFilterChange",item);
  }

  onDeSelectAll(items: any[]) {
  this.selectedItems = [];
}

  closeModal(){
    this.dialog.closeAll();
  }

  search(){
    this.page = 1;
    var idSensors = [];
    this.selectedItems.forEach(x => {
      idSensors.push(x.idSensor);
    });

    if(idSensors.length == 0){
      this.AlertService.showMessage(
        AppConstants.MessageModal.FILTER_SENSOR_VALIDATE,"",
        MessageSeverity.error);
      return false;
    }

    if(this.date > this.dateF){
      this.AlertService.showMessage(
        AppConstants.MessageModal.FILTER_DATES_VALIDATE,"",
        MessageSeverity.error);
      return false
    }

    this.getList();
  }

  getList(){
    var idSensors = [];
    this.selectedItems.forEach(x => {
      idSensors.push(x.idSensor);
    });
    console.log("idSensors",idSensors);
    var filter = {
      dateI: this.reportForm.value["startDateReport"],
      dateF: this.reportForm.value["endDateReport"],
      timeI: this.timeI,
      timeF: this.timeF,
      idEnterprise: this.enterpriseSelect,
      idHeadquarter: this.headquarterSelect,
      idGateway: 0, //this.gatewaySelect,
      idZone: this.zoneSelect,
      valueType: this.valueTypeSelect,
      idSensors: idSensors.toString(),
      Page: this.page,
      Rows: AppConstants.Paginado.DEFAULT_PAGE_SIZE_PAGINATION,
    };
    filter.dateI = this.datePipe.transform(filter.dateI, 'yyyy-MM-dd');
    filter.dateF = this.datePipe.transform(filter.dateF, 'yyyy-MM-dd');
    this.spinner.show();
    this.panelIOTService.reportSensors(filter).subscribe(
      result => {
        console.log(result);
        if(result.error == null){
          this.dataSource = new MatTableDataSource(result["rows"]);
          this.pageIndex = +result["page"]-1;
          this.length = result["total"];
          if(this.length == 0){
            this.AlertService.showMessage("No tiene registros", "", MessageSeverity.error);
          }
        }
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        this.AlertService.showMessage(AppConstants.TitleModal.ERROR_TITLE, error.error.messages, MessageSeverity.error);
         this.spinner.hide();
    });
  }

  getServerData(event?: PageEvent) {
    this.page = event.pageIndex + 1;
    this.getList();
  }

  exportAsExcel() {
    /* table id is passed over here */
    var idSensors = [];
    this.selectedItems.forEach(x => {
      idSensors.push(x.idSensor);
    });

    var filter = {
      dateI: this.reportForm.value["startDateReport"],
      dateF: this.reportForm.value["endDateReport"],
      timeI: this.timeI,
      timeF: this.timeF,
      idEnterprise: this.enterpriseSelect,
      idHeadquarter: this.headquarterSelect,
      idGateway: this.gatewaySelect,
      idZone: this.zoneSelect,
      valueType: this.valueTypeSelect,
      idSensors: idSensors.toString(),
      Page: this.page,
      Rows: AppConstants.Paginado.DEFAULT_PAGE_SIZE_PAGINATION,
    };
    filter.dateI = this.datePipe.transform(filter.dateI, 'yyyy-MM-dd');
    filter.dateF = this.datePipe.transform(filter.dateF, 'yyyy-MM-dd');
    this.spinner.show();
    this.panelIOTService.exportReportSensors(filter).subscribe(
      result => {
        console.log(result);
        if(result.error == null){
          this.createExcelWithChart(result.data);
        }
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        this.AlertService.showMessage(AppConstants.TitleModal.ERROR_TITLE, error.error.messages, MessageSeverity.error);
        this.spinner.hide();
    });
  }

  async createExcelWithChart(data: any[]) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Reporte Sensores');

    // Preparar datos para exportar
    let dataToExport = data.map(x => ({
      Sede: x.headquarter,
      Zona: x.zone,
      Sensor: x.sensor,
      Tipo: x.type,
      Fecha: x.date,
      Valor: x.value
    }));

    // Agregar encabezados
    const headers = ['Sede', 'Zona', 'Sensor', 'Tipo', 'Fecha', 'Valor'];
    worksheet.addRow(headers);

    // Estilizar encabezados
    const headerRow = worksheet.getRow(1);
    headerRow.font = { bold: true };
    headerRow.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFE0E0E0' }
    };

    // Agregar datos
    dataToExport.forEach(row => {
      worksheet.addRow([
        row.Sede,
        row.Zona,
        row.Sensor,
        row.Tipo,
        row.Fecha,
        row.Valor
      ]);
    });

    // Ajustar ancho de columnas
    worksheet.columns.forEach(column => {
      column.width = 15;
    });

    // Generar y agregar gráfico como imagen
    await this.addChartAsImage(worksheet, data, this.sensors);

    // Guardar archivo
    const date = new Date();
    const fileName = `reporte_sensores_actuadores-${date.getTime()}.xlsx`;
    
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    
    // Crear enlace de descarga
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.click();
    window.URL.revokeObjectURL(url);
  }

  async addChartAsImage(worksheet: ExcelJS.Worksheet, historicalData: any[], selectedSensors: any[]) {
    // Crear configuración de tipos con colores y límites
    const typeConfig = this.createTypeConfig(selectedSensors);
    
    // Agrupar datos históricos por tipo
    const groupedData = this.groupHistoricalDataByType(historicalData, typeConfig);
    
    // Agregar estadísticas
    const statsRow = historicalData.length + 3;


    // Generar gráficos para cada tipo (empezando desde la fila 2)
    let chartRow = 1; // Fila 2 (índice 1)
    for (const uniqueKey in groupedData) {
      if (groupedData.hasOwnProperty(uniqueKey)) {
        const typeData = groupedData[uniqueKey];
        const typeName = (typeData[0] && typeData[0].type) || 'Sin Tipo';
        
        // Buscar configuración por nombre del tipo
        const config = typeConfig[typeName];
        
        if (!config) {
          console.error(`No se encontró configuración para el tipo: ${typeName}`);
          console.log('Configuración disponible:', typeConfig);
          continue; // Saltar este tipo si no hay configuración
        }
        
        console.log(`Usando configuración para ${typeName}:`, config);
        
        const chartImageBase64 = await this.generateChartImage(
          typeData, 
          typeName, // Usar solo el nombre del tipo como título
          config.mainColor, 
          config.minAlert, 
          config.maxAlert
        );
      
        if (chartImageBase64) {
          const imageBuffer = this.base64ToBuffer(chartImageBase64);
          const imageId = worksheet.workbook.addImage({
            buffer: imageBuffer as any,
            extension: 'png',
          });

          // Posicionar el gráfico al lado de las columnas
          worksheet.addImage(imageId, {
            tl: { col: 7, row: chartRow }, // Columna H, fila variable
            ext: { width: 600, height: 400 }
          });
          
          chartRow += 25; // Espacio entre gráficos
        }
      }
    }
  }

  // Crear configuración de tipos con colores y límites
  createTypeConfig(selectedSensors: any[]): { [key: string]: any } {
    const typeConfig: { [key: string]: any } = {};
    
    // Si no hay sensores seleccionados, retornar configuración vacía
    if (!selectedSensors || selectedSensors.length === 0) {
      console.log('No hay sensores seleccionados');
      return typeConfig;
    }
    
    console.log('Sensores seleccionados:', selectedSensors);
    console.log('Tipo de valor seleccionado:', this.valueTypeSelect);
    
    selectedSensors.forEach(sensor => {
      if (sensor && sensor.sensorValues && sensor.sensorValues.length > 0) {
        // Filtrar solo el tipo de valor seleccionado
        console.log(`Procesando sensor ${sensor.sensor}, sensorValues:`, sensor.sensorValues);
        console.log(`Filtro de tipo: "${this.valueTypeSelect}"`);
        
        const filteredSensorValues = sensor.sensorValues.filter((sensorValue: any) => {
          // Si hay un filtro de tipo de valor, usar solo ese tipo
          if (this.valueTypeSelect && this.valueTypeSelect !== "0") {
            // Comparar tanto por name como por nomenclature
            const matches = sensorValue.name === this.valueTypeSelect || 
                           sensorValue.nomenclature === this.valueTypeSelect;
            console.log(`Comparando "${sensorValue.name}" (nomenclature: "${sensorValue.nomenclature}") con "${this.valueTypeSelect}": ${matches}`);
            return matches;
          }
          // Si no hay filtro, usar todos los tipos que tengan dataExportEnabled = true
          return sensorValue.dataExportEnabled === true;
        });
        
        console.log(`Valores filtrados para ${sensor.sensor}:`, filteredSensorValues);
        
        filteredSensorValues.forEach((sensorValue: any) => {
          if (sensorValue && sensorValue.name) {
            const typeName = sensorValue.name;
            if (!typeConfig[typeName]) {
              const minValue = parseFloat(sensorValue.minValue);
              const maxValue = parseFloat(sensorValue.maxValue);
              
              console.log(`Configurando ${typeName}: min=${minValue}, max=${maxValue}, color=${sensorValue.color}`);
              
              typeConfig[typeName] = {
                mainColor: sensorValue.color || this.getRandomColor(),
                minAlert: minValue,
                maxAlert: maxValue
              };
            }
          }
        });
      }
    });
    
    console.log('Configuración final:', typeConfig);
    return typeConfig;
  }

  // Agrupar datos históricos por tipo
  groupHistoricalDataByType(historicalData: any[], typeConfig: any): { [key: string]: any[] } {
    const grouped: { [key: string]: any[] } = {};
    
    // Si no hay datos históricos, retornar objeto vacío
    if (!historicalData || historicalData.length === 0) {
      return grouped;
    }
    
    historicalData.forEach(row => {
      if (row) {
        // Crear una clave única que combine sensor y tipo
        const sensorName = row.sensor || row.Sensor || 'Sensor';
        const typeName = row.sensorType || row.type || row.Tipo || 'Sin Tipo';
        const uniqueKey = `${sensorName} - ${typeName}`;
        
        if (!grouped[uniqueKey]) {
          grouped[uniqueKey] = [];
        }
        grouped[uniqueKey].push({
          date: row.dateLastValue || row.date || row.Fecha,
          value: parseFloat(row.value || row.Valor) || 0,
          type: typeName,
          sensor: sensorName
        });
      }
    });

    // Ordenar cada grupo por fecha
    Object.keys(grouped).forEach(key => {
      grouped[key].sort((a, b) => {
        const dateA = new Date(a.date);
        const dateB = new Date(b.date);
        return dateA.getTime() - dateB.getTime();
      });
    });

    return grouped;
  }

  groupDataByType(data: any[]): { [key: string]: any[] } {
    const grouped: { [key: string]: any[] } = {};
    
    data.forEach(row => {
      const type = row.Tipo || 'Sin Tipo';
      if (!grouped[type]) {
        grouped[type] = [];
      }
      grouped[type].push({
        date: row.Fecha,
        value: parseFloat(row.Valor) || 0,
        type: type
      });
    });

    // Ordenar cada grupo por fecha
    Object.keys(grouped).forEach(type => {
      grouped[type].sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
    });

    return grouped;
  }

  async generateChartImage(chartData: any[], typeName: string, mainColor: string, minAlert: number, maxAlert: number): Promise<string> {
    return new Promise((resolve) => {
      // Crear un canvas temporal
      const canvas = document.createElement('canvas');
      canvas.width = 600;
      canvas.height = 400;
      const ctx = canvas.getContext('2d');

      if (!ctx) {
        resolve('');
        return;
      }

      // Función para formatear fechas correctamente
      const formatDate = (dateString: string): string => {
        try {
          // Intentar diferentes formatos de fecha
          let date: Date;
          
          // Si es un string ISO
          if (dateString.includes('T') || dateString.includes('Z')) {
            date = new Date(dateString);
          }
          // Si es formato DD/MM/YYYY HH:MM:SS
          else if (dateString.includes('/') && dateString.includes(':')) {
            const [datePart, timePart] = dateString.split(' ');
            const [day, month, year] = datePart.split('/');
            const [hours, minutes, seconds] = timePart.split(':');
            date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day), parseInt(hours), parseInt(minutes), parseInt(seconds));
          }
          // Si es formato YYYY-MM-DD HH:MM:SS
          else if (dateString.includes('-') && dateString.includes(':')) {
            const [datePart, timePart] = dateString.split(' ');
            const [year, month, day] = datePart.split('-');
            const [hours, minutes, seconds] = timePart.split(':');
            date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day), parseInt(hours), parseInt(minutes), parseInt(seconds));
          }
          // Formato por defecto
          else {
            date = new Date(dateString);
          }

          // Verificar si la fecha es válida
          if (isNaN(date.getTime())) {
            return dateString; // Retornar el string original si no se puede parsear
          }

          // Formatear como DD/MM HH:MM
          const padStart = (str: string, length: number, pad: string): string => {
            return (pad.repeat(length) + str).slice(-length);
          };
          
          const day = padStart(date.getDate().toString(), 2, '0');
          const month = padStart((date.getMonth() + 1).toString(), 2, '0');
          const hours = padStart(date.getHours().toString(), 2, '0');
          const minutes = padStart(date.getMinutes().toString(), 2, '0');
          
          return `${day}/${month} ${hours}:${minutes}`;
        } catch (error) {
          return dateString; // Retornar el string original en caso de error
        }
      };

      // Crear el gráfico
      const chart = new Chart(ctx, {
        type: 'line',
        data: {
          labels: chartData.map(d => formatDate(d.date)),
          datasets: [
            // Dataset principal con el color azul claro como en la segunda imagen
            {
              label: typeName,
              data: chartData.map(d => d.value),
              borderColor: '#87CEEB', // Azul claro como en la segunda imagen
              backgroundColor: 'rgba(135, 206, 235, 0.1)', // Azul claro transparente
              tension: 0.1,
              fill: false,
              pointRadius: 0, // Sin puntos como en la segunda imagen
              pointHoverRadius: 0,
              borderWidth: 2
            },
            // Línea de límite mínimo
            {
              label: `Límite Mínimo (${minAlert})`,
              data: chartData.map(() => minAlert),
              borderColor: '#ff4444',
              backgroundColor: 'rgba(255, 68, 68, 0.1)',
              borderDash: [5, 5],
              pointRadius: 0,
              pointHoverRadius: 0,
              borderWidth: 2,
              fill: false
            },
            // Línea de límite máximo
            {
              label: `Límite Máximo (${maxAlert})`,
              data: chartData.map(() => maxAlert),
              borderColor: '#ff4444',
              backgroundColor: 'rgba(255, 68, 68, 0.1)',
              borderDash: [5, 5],
              pointRadius: 0,
              pointHoverRadius: 0,
              borderWidth: 2,
              fill: false
            }
          ]
        },
        options: {
          responsive: false,
          maintainAspectRatio: false,
          // Configuración de modo dark como en la segunda imagen
          backgroundColor: '#1a1a1a', // Fondo muy oscuro
          plugins: {
            title: {
              display: true,
              text: typeName, // Usar el nombre del tipo como título
              color: '#ffffff', // Texto blanco
              font: {
                size: 16,
                weight: 'bold'
              }
            },
            legend: {
              display: false // Sin leyenda como en la segunda imagen
            }
          },
          scales: {
            y: {
              beginAtZero: false,
              grid: {
                color: '#333333', // Líneas de cuadrícula sutiles
                drawBorder: false,
                borderColor: '#333333'
              },
              title: {
                display: false // Sin título del eje Y
              },
              ticks: {
                color: '#ffffff', // Texto blanco
                font: {
                  size: 10
                }
              }
            },
            x: {
              grid: {
                color: '#333333', // Líneas de cuadrícula sutiles
                drawBorder: false,
                borderColor: '#333333'
              },
              title: {
                display: false // Sin título del eje X
              },
              ticks: {
                color: '#ffffff', // Texto blanco
                font: {
                  size: 10
                },
                maxRotation: 90, // Texto vertical como en la segunda imagen
                minRotation: 90  // Texto vertical como en la segunda imagen
              }
            }
          }
        }
      });

      // Esperar a que el gráfico se renderice y luego obtener la imagen
      setTimeout(() => {
        const imageBase64 = canvas.toDataURL('image/png');
        chart.destroy(); // Limpiar el gráfico
        resolve(imageBase64);
      }, 1000);
    });
  }

  base64ToBuffer(base64: string): Uint8Array {
    const base64Data = base64.split(',')[1];
    const binaryString = atob(base64Data);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
  }

  // Función para generar color aleatorio si no se proporciona
  private getRandomColor(): string {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  // Función para convertir hex a rgba
  private hexToRgba(hex: string, alpha: number): string {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }


  changeEnterprise(data) {
    this.enterpriseSelect = data.value;
    this.getHeadquarters();
  }

  getHeadquarters(){
    //if (this.isAdminGys) {
      this.spinner.show();
      this.headquarterService.getListAll().subscribe((response) => {
        if(response.error == null){
          this.headquarters = response.data.filter(f => f.idEnterprise == this.enterpriseSelect);
          this.headquarterSelect = 0;
          this.spinner.hide();
          this.getZonesList();
          this.getValueTypes();
        }else{
          this.headquarters = [];
          this.gateways = [];
          this.spinner.hide();
        }
      },
        (error: HttpErrorResponse) => {
          this.headquarters = [];
          this.gateways = [];
          this.spinner.hide();
        });
   /* } else {
        this.headquarterSelect = +localStorage.getItem(AppConstants.Session.HEADQUARTER);
      } */
  }

  getGateways(){
    this.gatewayService.getListAll().subscribe((_) => {
      if(_.error == null){
        if(this.headquarterSelect == 0){
          this.gateways = _.data.filter(x => x.idEnterprise == this.enterpriseSelect);
        }else{
          this.gateways = _.data.filter(x => x.idEnterprise == this.enterpriseSelect && x.idHeadquarter == this.headquarterSelect);
        }

        if(this.gateways.length == 1){
          this.gatewaySelect = this.gateways[0]["id"];
        }else{
          this.gatewaySelect = 0;
        }
      }
      this.getSensors();
    });
  }

  getZonesList() {
    this.zoneService.getListAll(this.enterpriseSelect,this.headquarterSelect).subscribe((response) => {
      if(response.error == null){
        this.zones = response.data.filter(x => x.type == 2);
        if(this.zones.length == 1){
          this.zoneSelect = this.zones[0]["id"];
        }else if(this.zones.length>1){
          this.zoneSelect = 0;
        }else{
          this.AlertService.showMessage("No tiene zonas IOT registradas, debes de crear una zona para usar este módulo", "", MessageSeverity.error);
        }
      }
      this.getGateways();
      this.spinner.hide();
    },
      (error: HttpErrorResponse) => {
        this.spinner.hide();
      });
  }

  getSensors(){
    var filter = {
      idEnterprise: this.enterpriseSelect,
      idHeadquarter: this.headquarterSelect,
      idZone: this.zoneSelect,
      idGateway: this.gatewaySelect
    }
    this.spinner.show();
    this.selectedItems = [];
    this.panelIOTService.getList(filter).subscribe((_) => {
      this.sensors = [];
      if(_.error == null){
        var s = _.data;//.filter(x => x.stateSensor != "instalado");
        this.sensors= this.sensors.concat(s);
        console.log("sensors",this.sensors);
      }
      this.spinner.hide();
    });
  }

  getValueTypes(){
    var filter = {
      idEnterprise: this.enterpriseSelect,
      idHeadquarter: this.headquarterSelect
    }
    this.spinner.show();
    this.panelIOTService.getListValueTypes(filter).subscribe((_) => {
      if(_.error == null){
        this.valueTypes = _.data;
      }
      this.spinner.hide();
    });
  }

  changeGateway(data) {
    this.gatewaySelect = data.value;
    this.getSensors();
    //this.getList(1);
  }

  changeZone(data) {
    this.selectedItems = [];
    this.reportForm.get('idSensors').setValue([]);
    this.zoneSelect = data.value;
    if(this.zoneSelect > 0){
      var zone = this.zones.filter(x => x.id == data.value)[0];
      this.headquarterSelect = zone.idHeadquarter;
    }else{
      this.headquarterSelect = 0;
    }
    this.getGateways();
    this.getSensors();
  }

  changeValueType(data) {
    //this.selectedItems = [];
    //this.reportForm.get('idSensors').setValue([]);
    this.valueTypeSelect = data.value;
  }

  changeHeadquarter(data) {
    this.headquarterSelect = data.value;
    this.selectedItems = [];
    this.reportForm.get('idSensors').setValue([]);
    this.getZonesList();
  }

}

